module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-SemiBold.bc49920.ttf";